const runtimeConfig =
  typeof window !== 'undefined' && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

export const graphqlUrl =
  runtimeConfig.VUE_APP_GRAPHQL_URL || process.env.VUE_APP_GRAPHQL_URL;

if (!graphqlUrl) {
  throw new Error('Missing GraphQL URL configuration');
}
